import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    scrolling: false,
}

const scrollSlice = createSlice({
    name: `scroll`,
    initialState,
    reducers: {
        scrolling: (state) => ({
            ...state,
            scrolling: true,
        }),
        stopScrolling: (state) => ({
            ...state,
            scrolling: false,
        }),
    },
})

export const scrollActions = scrollSlice.actions

export default scrollSlice.reducer
